import Title from "../Common/Title";
import {ic_left_arrow} from "../Hotel/images";

const Heading = ({title}) => {
    const goBack = () => {
		window.history.back();
	};
    return (
        <div className="flex gap-2 items-center cursor-pointer" onClick={goBack}>
            <img src={ic_left_arrow}  alt="SOU-Hotel_ic_left_arrow" className="h-6 w-6" /> <Title title={title} size="6xl" as="h1" className="!text-primary"/>
        </div>
    )
}

export default Heading;